import type { ReactNode } from 'react';

/** Seção numerada (`.sec` + `.sec-head`). */
export function Sec({ num, titulo, sub, acoes, children, className }:
  { num?: number | string; titulo: ReactNode; sub?: ReactNode; acoes?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={['sec', className].filter(Boolean).join(' ')}>
      <div className="sec-head">
        {num !== undefined && <span className="num">{num}</span>}
        <h3>{titulo}</h3>
        {sub && <span className="sub">{sub}</span>}
        {acoes && <span className="acoes">{acoes}</span>}
      </div>
      {children}
    </section>
  );
}

export function Tabs<T extends string>({ valor, onChange, itens }:
  { valor: T; onChange: (v: T) => void; itens: ReadonlyArray<{ id: T; rotulo: ReactNode; contador?: number }> }) {
  return (
    <div className="tabs" role="tablist">
      {itens.map((it) => (
        <button key={it.id} type="button" role="tab" className={it.id === valor ? 'active' : undefined} onClick={() => onChange(it.id)}>
          {it.rotulo}{it.contador !== undefined && <span className="ct">{it.contador}</span>}
        </button>
      ))}
    </div>
  );
}

export function Modal({ titulo, aberto, onFechar, children, acoes, estreito, largo }:
  { titulo: ReactNode; aberto: boolean; onFechar: () => void; children: ReactNode; acoes?: ReactNode; estreito?: boolean; /** formulário grande (cadastro em abas) */ largo?: boolean }) {
  if (!aberto) return null;
  return (
    <div className="modal-bg" onMouseDown={(e) => { if (e.target === e.currentTarget) onFechar(); }}>
      <div className={`modal${estreito ? ' estreito' : ''}${largo ? ' largo' : ''}`} role="dialog" aria-modal="true">
        <h3>{titulo}</h3>
        {children}
        {acoes && <div className="modal-acoes">{acoes}</div>}
      </div>
    </div>
  );
}

export function Pill({ cor, children }: { cor?: 'verde' | 'ambar' | 'verm' | 'azul' | 'acento'; children: ReactNode }) {
  return <span className={['pill', cor].filter(Boolean).join(' ')}>{children}</span>;
}

export function Kpi({ rotulo, valor, sub, cor }: { rotulo: ReactNode; valor: ReactNode; sub?: ReactNode; cor?: 'verde' | 'verm' | 'ambar' | 'azul' }) {
  return (
    <div className={['kpi', cor].filter(Boolean).join(' ')}>
      <div className="rot">{rotulo}</div>
      <div className="val">{valor}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
